import {
  AGREEMENT_ACCEPTANCE_DESER,
  AgreementAcceptance,
  type AgreementInput,
} from "../../tastyworks/agreement"
import type HttpClient from "../../tastyworks/http"
import {
  parseItemsResponse,
  type ItemsResponse,
} from "../../tastyworks/response"

export class AgreementService {
  constructor(private readonly customerMeClient: HttpClient) {}

  readonly create = async (
    agreements: AgreementInput[]
  ): Promise<ItemsResponse<AgreementAcceptance>> => {
    const helper = await this.customerMeClient.postJson("agreements", {
      agreements,
      "acceptance-method": "Click",
    })

    return parseItemsResponse(
      helper,
      AGREEMENT_ACCEPTANCE_DESER.toParser(AgreementAcceptance)
    )
  }
}
